import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getInitials } from "../../../utils/utils";
import { UpdateBaseUrlApi } from "../../../api/request/auth";
import { setloggedIn, setUserDetails } from "../../../store/Slices/userSlice";
import { Avatar, Segmented, Spin } from "antd";
import Plus from "../../../assets/Plus";
import MySegmented from "../../segmented/Segmented";
import GlobalLoader from "../../loader/GlobalLoader";
import axios from "axios";

export default function Header({
  collapsed,
  setCollapsed,
  isDrawerOpen,
  setIsDrawerOpen,
  title,
}) {
  const userDetails = useSelector((state) => state.user.userDetails);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [value, setValue] = useState(
    userDetails?.base_url || "https://staging-backend.trackmydoc.com/api/"
  );
  const [isLoading, setIsLoading] = useState(false);
  const options = [
    { label: "Live", value: "https://live-backend.trackmydoc.com/api/" },
    { label: "Staging", value: "https://staging-backend.trackmydoc.com/api/" },
  ];

  const handleChange = async (val) => {
    setValue(val);
    try {
      setIsLoading(true);
      await axios.post(
        "https://live-backend.trackmydoc.com/api/update-base-url",
        { base_url: val }
      );
      await axios.post(
        "https://staging-backend.trackmydoc.com/api/update-base-url",
        { base_url: val }
      );
      dispatch(setUserDetails({ base_url: val }));
      dispatch(setloggedIn(false));
    } catch (error) {
      console.error("API error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <GlobalLoader size="large" className="fixed top-0 left-0 z-10 bg-white" />
    );
  }

  return (
    <div className="border-b p-4 bg-White">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <svg
            onClick={() => setCollapsed(!collapsed)}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-6 h-6 cursor-pointer hidden lg:block"
          >
            <path
              fill-rule="evenodd"
              d="M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm0 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z"
              clip-rule="evenodd"
            />
          </svg>
          <svg
            onClick={() => setIsDrawerOpen(!isDrawerOpen)}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-6 h-6 cursor-pointer lg:hidden"
          >
            <path
              fill-rule="evenodd"
              d="M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm0 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z"
              clip-rule="evenodd"
            />
          </svg>
          <p className="page-title capitalize hidden lg:block">{title}</p>
        </div>
        <div className="flex items-center gap-5">
          <div className="w-48">
            <MySegmented
              size="default"
              options={options}
              value={value}
              setValue={setValue}
              onChange={handleChange}
              className="custom-segmented !bg-bgColor !px-1 !py-1 text-sm"
            />
          </div>
          <button
            className="ms-auto flex px-4 py-2 bg-secondary text-white rounded-md"
            onClick={(e) => {
              navigate("/license", { state: { status: "add" } });
            }}
          >
            <Plus /> Add License
          </button>
          <div className="flex items-center gap-3 divide-x-2">
            {/* <div className="border-Gray border h-10  w-10 rounded-full flex justify-center items-center">
              <img
                src="/assets/icons/notification-bell.svg"
                className="h-6 cursor-pointer"
                alt="icon"
              />
            </div> */}
            <div className="sm:ps-3 ps-2">
              {" "}
              {/* onClick={() => navigate("/settings")} */}
              <div className="flex items-center gap-3 cursor-pointer">
                <Avatar
                  size="large"
                  className="bg-primary uppercase"
                  src={userDetails?.profile_image}
                >
                  {getInitials(userDetails?.name)}
                </Avatar>
                <div className="md:block hidden">
                  <p className="leading-5 capitalize mid-title">
                    {userDetails?.name}
                  </p>
                  <p className="text-secondaryLight1">{userDetails?.email}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
